export default __webpack_public_path__ + "static/media/logo.8716a3b6.png";